"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CrosstabTable = _interopRequireDefault(require("./CrosstabTable.js"));
var _CrosstabSummaryTable = _interopRequireDefault(require("./CrosstabSummaryTable.js"));
var _cccisdVisualize = require("cccisd-visualize");
var _color = _interopRequireDefault(require("color"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Content = function Content(props) {
  var currentMetric = props.currentMetric,
    currentCrossMetric = props.currentCrossMetric,
    data = props.data,
    currentMetricSettings = props.currentMetricSettings;
  var _useMemo = (0, _react.useMemo)(function () {
      var allowRollup = currentMetricSettings.chartType !== 'none';
      var rollupThreshold = allowRollup && currentMetricSettings.enableRollupThreshold ? currentMetricSettings.rollupThresholdValue : 0;
      var metricCoding = currentMetric.enumCoding ? Object.entries(currentMetric.enumCoding).reduce(function (obj, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        obj[value] = key;
        return obj;
      }, {}) : null;
      var crossMetricCoding = currentCrossMetric.enumCoding ? Object.entries(currentCrossMetric.enumCoding).reduce(function (obj, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        obj[value] = key;
        return obj;
      }, {}) : null;
      var columns = data.crosstabSummaryStats.filter(function (item) {
        return item.value;
      }).map(function (item) {
        return {
          code: item.value,
          total: item.valueCount,
          label: crossMetricCoding[item.value]
        };
      });
      if (rollupThreshold > 0 && columns.length > rollupThreshold + 1) {
        columns.sort(function (a, b) {
          if (b.total !== a.total) {
            return b.total - a.total;
          }
          if (typeof a.label === 'string' && typeof b.label === 'string') {
            return a.label.localeCompare(b.label);
          }
          return 0;
        });
        var otherTotal = columns.length - rollupThreshold;
        var otherColumn = columns.slice(rollupThreshold).reduce(function (obj, row) {
          obj.total += row.total;
          return obj;
        }, {
          code: 'others',
          label: "".concat(otherTotal, " others"),
          total: 0,
          isOthers: true
        });
        columns = columns.slice(0, rollupThreshold);
        columns.push(otherColumn);
      }
      var rows = data.frequency.filter(function (item) {
        return item.value;
      }).map(function (item) {
        var values = item.frequency.reduce(function (obj, item1) {
          obj[item1.value] = item1.valueCount;
          return obj;
        }, {});
        return _objectSpread({
          total: Number(item.valueCount),
          label: currentMetric.enumCoding ? metricCoding[item.value] : item.value,
          values: columns.map(function (column) {
            var value = values[column.code];
            if (value) {
              delete values[column.code];
              return value;
            }
            if (column.isOthers) {
              return Object.values(values).reduce(function (sum, num) {
                return sum + num;
              }, 0);
            }
            return 0;
          })
        }, currentMetric.enumCoding ? {
          code: item.value
        } : {});
      });
      var crosstab = function () {
        var _currentMetric$conten;
        var result = {
          columns: columns,
          rows: _toConsumableArray(rows)
        };
        if (currentMetric.enumCoding) {
          var existingLabels = result.rows.reduce(function (obj, item) {
            obj.add(item.label);
            return obj;
          }, new Set());
          for (var _i2 = 0, _Object$entries = Object.entries(currentMetric.enumCoding); _i2 < _Object$entries.length; _i2++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
              label = _Object$entries$_i[0],
              code = _Object$entries$_i[1];
            if (!existingLabels.has(label)) {
              result.rows.push({
                total: 0,
                label: label,
                code: code,
                values: columns.map(function (_) {
                  return 0;
                })
              });
            }
          }
        }
        if (rollupThreshold > 0 && result.rows.length > rollupThreshold + 1) {
          result.rows.sort(function (a, b) {
            if (b.total !== a.total) {
              return b.total - a.total;
            }
            if (typeof a.label === 'string' && typeof b.label === 'string') {
              return a.label.localeCompare(b.label);
            }
            return 0;
          });
          var _otherTotal = result.rows.length - rollupThreshold;
          var otherRow = result.rows.slice(rollupThreshold).reduce(function (obj, row) {
            obj.total += row.total;
            for (var i = 0; i < result.columns.length; i++) {
              obj.values[i] += row.values[i];
            }
            return obj;
          }, {
            label: "".concat(_otherTotal, " others"),
            total: 0,
            values: result.columns.map(function (_) {
              return 0;
            }),
            isOthers: true
          });
          result.rows = result.rows.slice(0, rollupThreshold);
          result.rows.push(otherRow);
        } else if ((_currentMetric$conten = currentMetric.content) !== null && _currentMetric$conten !== void 0 && _currentMetric$conten.enumDisplayText) {
          // Sort by enum order
          var order = currentMetric.content.enumDisplayText.reduce(function (obj, item, index) {
            obj[item] = index;
            return obj;
          }, {});
          result.rows.sort(function (a, b) {
            return order[a.label] - order[b.label];
          });
        }
        return result;
      }();

      // fix total, because total from DB includes null values
      var _iterator = _createForOfIteratorHelper(crosstab.rows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          row.total = row.values.reduce(function (sum, num) {
            return sum + num;
          }, 0);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _loop = function _loop(i) {
        var column = crosstab.columns[i];
        column.total = crosstab.rows.reduce(function (sum, row) {
          return sum + row.values[i];
        }, 0);
      };
      for (var i = 0; i < crosstab.columns.length; i++) {
        _loop(i);
      }
      var summary = function () {
        if (!currentMetricSettings.showSummaryStats) {
          return [];
        }
        var stats = data.crosstabSummaryStats.filter(function (item) {
          return item.value;
        }).reduce(function (obj, item) {
          obj[item.value] = item;
          return obj;
        }, {});
        return {
          columns: columns,
          rows: [{
            label: 'Mean',
            key: 'avg'
          }, {
            label: 'Stddev',
            key: 'stddev'
          }, {
            label: 'Min',
            key: 'min'
          }, {
            label: 'Max',
            key: 'max'
          }].map(function (item) {
            return {
              label: item.label,
              values: crosstab.columns.filter(function (column) {
                return !column.isOthers;
              }).map(function (column) {
                return stats[column.code][item.key];
              }),
              total: data[item.key]
            };
          })
        };
      }();
      var chart = function () {
        if (currentMetricSettings.chartType === 'bar') {
          if (currentMetricSettings.visualizeAs === 'mean') {
            return data.crosstabSummaryStats.filter(function (item) {
              return item.avg !== null;
            }).map(function (item) {
              return {
                id: item.value,
                mean: item.avg
              };
            });
          }
          return crosstab.rows.map(function (row) {
            var obj = {
              label: row.label
            };
            for (var _i3 = 0; _i3 < crosstab.columns.length; _i3++) {
              var column = crosstab.columns[_i3];
              obj[column.label] = row.values[_i3];
            }
            return obj;
          });
        }
        if (currentMetricSettings.chartType === 'line') {
          if (currentMetricSettings.visualizeAs === 'mean') {
            return [{
              id: 'mean',
              data: data.crosstabSummaryStats.filter(function (item) {
                return item.avg !== null;
              }).map(function (item) {
                return {
                  x: item.value,
                  y: item.avg
                };
              })
            }];
          }
          return crosstab.rows.map(function (row) {
            return {
              id: row.label,
              data: columns.map(function (column, index) {
                return {
                  x: column.label,
                  y: row.values[index]
                };
              })
            };
          });
        }
        return [];
      }();
      return {
        crosstabData: crosstab,
        chartData: chart,
        summaryData: summary
      };
    }, [currentMetric, currentCrossMetric, data, currentMetricSettings]),
    crosstabData = _useMemo.crosstabData,
    chartData = _useMemo.chartData,
    summaryData = _useMemo.summaryData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, currentMetricSettings.chartType === 'bar' && /*#__PURE__*/_react["default"].createElement("div", {
    key: currentMetricSettings.visualizeAs,
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bar, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.bar), currentMetricSettings.visualizeAs === 'mean' ? {
      keys: ['mean']
    } : {
      keys: crosstabData.columns.map(function (column) {
        return column.label;
      }),
      indexBy: 'label',
      labelSkipHeight: 0,
      // Show zero value if there is no data
      label: function label(d) {
        if (Object.keys(d.data).length > 1) {
          return d.value > 0 ? d.value : '';
        }
        return /*#__PURE__*/_react["default"].createElement("tspan", {
          y: "-12"
        }, d.value);
      },
      labelTextColor: function labelTextColor(item) {
        var value = item.data.value;
        var color = (0, _color["default"])(item.color).hsl();
        var lightness = color.color[2];
        var newLightness = lightness > 60 ? Math.min(lightness - 60, 20) : 100;
        if (value === 0 && newLightness > 80) {
          newLightness = 20;
        }
        return color.lightness(newLightness).hex();
      }
    })
  })), currentMetricSettings.chartType === 'line' && /*#__PURE__*/_react["default"].createElement("div", {
    key: currentMetricSettings.visualizeAs,
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Line, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.line), {}, {
      keys: ['mean']
    })
  })), currentMetricSettings.showTable || currentMetricSettings.showSummaryStats ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tables
  }, currentMetricSettings.showTable ? /*#__PURE__*/_react["default"].createElement(_CrosstabTable["default"], {
    data: crosstabData
  }) : null, currentMetricSettings.showSummaryStats ? /*#__PURE__*/_react["default"].createElement(_CrosstabSummaryTable["default"], {
    data: summaryData
  }) : null) : null);
};
Content.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  data: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object
};
var _default = Content;
exports["default"] = _default;